<div *ngIf="type === 'barcode'">
  <table>
    <ng-container *ngFor="let field of config.doc">
      <tr *ngIf="model.doc && (!print || model.doc[field.code])">
        <td>
          <input *ngIf="!print" type="checkbox" [(ngModel)]="model.doc[field.code]" (change)="setModel()" [attr.disabled]="disabled ? true : null"/>
          {{field.name}}<br>
          <ngx-barcode 
            [bc-value]="field.value[0]" 
            [bc-element-type]="'svg'" 
            [bc-format]="bcFormat" 
            [bc-width]="field.value[0]?.length > 25 ? 50 / field.value[0].length : 2" 
            [bc-height]="79"
            [bc-font]="'OCRB'"
            [bc-font-size]="field.value[0]?.length > 40 ? 1300 / (field.value[0].length + 40) : 20"
            [bc-text-align]="'left'"
            [bc-display-value]="true">
          </ngx-barcode>
        </td>
      </tr>
    </ng-container>
  </table>
  <table>
    <tbody *ngFor="let li of compilation.lineItems; index as idx">
      <ng-container *ngFor="let field of config.item">
        <tr *ngIf="model.items[idx] && (!print || model.items[idx][field.code])">
          <td>
            <input *ngIf="!print" type="checkbox" [(ngModel)]="model.items[idx][field.code]" (change)="setModel()" [attr.disabled]="disabled ? true : null"/>
            Pos [{{idx+1}}] {{field.name}}<br>
            <ngx-barcode
              [bc-value]="field.value[idx]" 
              [bc-element-type]="'svg'" 
              [bc-format]="bcFormat" 
              [bc-width]="field.value[idx]?.length > 25 ? 50 / field.value[idx].length : 2" 
              [bc-height]="79" 
              [bc-font]="'OCRB'"
              [bc-font-size]="field.value[0]?.length > 40 ? 1300 / (field.value[idx].length + 40) : 20"
              [bc-text-align]="'left'"
              [bc-display-value]="true">
            </ngx-barcode>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>

<div *ngIf="type === 'qrcode'" style="text-align:center">
  <qrcode
    [qrdata]="qrData"
    [allowEmptyString]="true"
    [ariaLabel]="'QR Code image with the following content...'"
    [cssClass]="'center'"
    [colorDark]="'#000000ff'"
    [colorLight]="'#ffffffff'"
    [elementType]="'svg'"
    [errorCorrectionLevel]="'M'"
    [margin]="2"
    [scale]="32"
    [title]="'QR Code'"
    [width]="400"
  ></qrcode>
</div>